/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class BuyerRequirementsService {
    /**
     * List all buyer requirements
     * Retrieve a list of buyer requirements with optional filters.
     *
     * Note: Buyer requirements are automatically created when products/services are added to a location with buying=true,
     * and automatically deleted when all buying products/services for that category are removed.
     *
     * @param cid Filter by corporate entity ID
     * @param userid Filter by user ID
     * @param category Filter by category
     * @param priority Filter by priority level
     * @returns any List of buyer requirements
     * @throws ApiError
     */
    public static getApiV2BuyerRequirements(
        cid?: number,
        userid?: number,
        category?: string,
        priority?: 'LOW' | 'MEDIUM' | 'HIGH',
    ): CancelablePromise<Array<{
        /**
         * The auto-generated ID of the requirement
         */
        id?: number;
        /**
         * The corporate entity ID
         */
        cid: number;
        /**
         * The user ID (optional)
         */
        userid?: number;
        /**
         * Product or service category needed
         */
        category: string;
        /**
         * Required quantity or volume
         */
        quantity?: string;
        /**
         * Timeline or urgency of the requirement
         */
        timeline?: string;
        /**
         * Budget constraints or range
         */
        budget?: string;
        /**
         * Geographic preferences or restrictions
         */
        geography?: string;
        /**
         * Priority level of the requirement
         */
        priority?: 'LOW' | 'MEDIUM' | 'HIGH';
        /**
         * Additional notes or specifications
         */
        notes?: string;
        /**
         * Creation timestamp
         */
        created?: string;
        /**
         * Last update timestamp
         */
        updated?: string;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/buyer-requirements',
            query: {
                'cid': cid,
                'userid': userid,
                'category': category,
                'priority': priority,
            },
        });
    }
    /**
     * Get a specific buyer requirement
     * Retrieve a buyer requirement by its ID
     * @param id The buyer requirement ID
     * @returns any Buyer requirement found
     * @throws ApiError
     */
    public static getApiV2BuyerRequirements1(
        id: number,
    ): CancelablePromise<{
        /**
         * The auto-generated ID of the requirement
         */
        id?: number;
        /**
         * The corporate entity ID
         */
        cid: number;
        /**
         * The user ID (optional)
         */
        userid?: number;
        /**
         * Product or service category needed
         */
        category: string;
        /**
         * Required quantity or volume
         */
        quantity?: string;
        /**
         * Timeline or urgency of the requirement
         */
        timeline?: string;
        /**
         * Budget constraints or range
         */
        budget?: string;
        /**
         * Geographic preferences or restrictions
         */
        geography?: string;
        /**
         * Priority level of the requirement
         */
        priority?: 'LOW' | 'MEDIUM' | 'HIGH';
        /**
         * Additional notes or specifications
         */
        notes?: string;
        /**
         * Creation timestamp
         */
        created?: string;
        /**
         * Last update timestamp
         */
        updated?: string;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/buyer-requirements/{id}',
            path: {
                'id': id,
            },
            errors: {
                404: `Buyer requirement not found`,
            },
        });
    }
    /**
     * Update a buyer requirement
     * Update an existing buyer requirement by its ID. Use this endpoint to update additional details such as:
     * quantity, timeline, budget, geography, priority, and notes.
     *
     * Note: The cid, category, and userid fields are set at creation and cannot be updated.
     *
     * @param id The buyer requirement ID
     * @param requestBody
     * @returns any Buyer requirement updated
     * @throws ApiError
     */
    public static putApiV2BuyerRequirements(
        id: number,
        requestBody: {
            /**
             * Required quantity or volume
             */
            quantity?: string;
            /**
             * Timeline or urgency of the requirement
             */
            timeline?: string;
            /**
             * Budget constraints or range
             */
            budget?: string;
            /**
             * Geographic preferences or restrictions
             */
            geography?: string;
            /**
             * Priority level of the requirement
             */
            priority?: 'LOW' | 'MEDIUM' | 'HIGH';
            /**
             * Additional notes or specifications
             */
            notes?: string;
        },
    ): CancelablePromise<{
        /**
         * The auto-generated ID of the requirement
         */
        id?: number;
        /**
         * The corporate entity ID
         */
        cid: number;
        /**
         * The user ID (optional)
         */
        userid?: number;
        /**
         * Product or service category needed
         */
        category: string;
        /**
         * Required quantity or volume
         */
        quantity?: string;
        /**
         * Timeline or urgency of the requirement
         */
        timeline?: string;
        /**
         * Budget constraints or range
         */
        budget?: string;
        /**
         * Geographic preferences or restrictions
         */
        geography?: string;
        /**
         * Priority level of the requirement
         */
        priority?: 'LOW' | 'MEDIUM' | 'HIGH';
        /**
         * Additional notes or specifications
         */
        notes?: string;
        /**
         * Creation timestamp
         */
        created?: string;
        /**
         * Last update timestamp
         */
        updated?: string;
    }> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v2/buyer-requirements/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input data`,
                404: `Buyer requirement not found`,
            },
        });
    }
    /**
     * Get all requirements for a corporate entity
     * Retrieve all buyer requirements associated with a specific corporate entity
     * @param id The corporate entity ID
     * @returns any List of buyer requirements for the corporate entity
     * @throws ApiError
     */
    public static getApiV2BuyerRequirementsCorporate(
        id: number,
    ): CancelablePromise<Array<{
        /**
         * The auto-generated ID of the requirement
         */
        id?: number;
        /**
         * The corporate entity ID
         */
        cid: number;
        /**
         * The user ID (optional)
         */
        userid?: number;
        /**
         * Product or service category needed
         */
        category: string;
        /**
         * Required quantity or volume
         */
        quantity?: string;
        /**
         * Timeline or urgency of the requirement
         */
        timeline?: string;
        /**
         * Budget constraints or range
         */
        budget?: string;
        /**
         * Geographic preferences or restrictions
         */
        geography?: string;
        /**
         * Priority level of the requirement
         */
        priority?: 'LOW' | 'MEDIUM' | 'HIGH';
        /**
         * Additional notes or specifications
         */
        notes?: string;
        /**
         * Creation timestamp
         */
        created?: string;
        /**
         * Last update timestamp
         */
        updated?: string;
    }>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/buyer-requirements/corporate/{id}',
            path: {
                'id': id,
            },
        });
    }
}
